import "../../styles/about/coursestreams.css"; // Import custom CSS file
import course from "../../assets/coursestream.jpeg";

const CourseStreams = () => {
  // Data for the course list to keep the code clean
  const courseData = [
    {
      id: 1,
      title: "Tuition Programs",
      description:
        "CBSE & State Board coaching for Classes 1–12, with a focus on building strong academic foundations.",
      link: "https://tuition.madhiacademy.com", // Replace with actual URLs
    },
    {
      id: 2,
      title: "Indian Professional Courses",
      description:
        "Chartered Accountant (CA), Cost & Management Accountant (CMA), and Company Secretary (CS) training with high pass rates.",
      link: "https://pro.madhiacademy.com",
    },
    {
      id: 3,
      title: "Global Professional Courses",
      description:
        "International certifications including US CPA, US CMA, and EA, preparing students for global career opportunities.",
      link: "https://global.madhiacademy.com",
    },
    {
      id: 4,
      title: "Commerce Degrees",
      description:
        "Integrated B.Com programs combined with professional course preparation.",
      link: "https://degree.madhiacademy.com",
    },
    {
      id: 5,
      title: "Skills Training",
      description:
        "Practical job-oriented training in ERP, Computer basics, and English communication.",
      link: "https://skills.madhiacademy.com",
    },
  ];

  return (
    <section className="course-streams-section py-5 my-4">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column: Text and List */}
          <div className="col-lg-7 mb-5 mb-lg-0 pe-lg-5">
            {/* Headings */}
            <h2 className="fw-bold text-dark mb-2 display-6">
              Our Course Streams
            </h2>
            <div className="mb-5">
              <h3 className="text-purple fw-bold d-inline-block position-relative wavy-underline pb-3">
                Explore Your Learning Path
              </h3>
            </div>

            {/* Course List */}
            <div className="d-flex flex-column gap-3">
              {courseData.map((course) => (
                <a
                  key={course.id}
                  href={course.link}
                  target={course.external ? "_blank" : "_self"}
                  rel={course.external ? "noopener noreferrer" : undefined}
                  className="course-card-link text-decoration-none color-inherit"
                >
                  <div className="course-card d-flex align-items-start p-3 rounded border bg-white">
                    <i className="bi bi-check-circle-fill text-purple fs-4 me-3 flex-shrink-0 mt-1"></i>
                    <div>
                      <h5 className="fw-bold text-dark mb-2">{course.title}</h5>
                      <p className="text-muted small mb-0">
                        {course.description}
                      </p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="col-lg-5">
            <img
              src={course}
              alt="Students learning in a classroom"
              className="img-fluid rounded-4 shadow-sm w-100"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseStreams;
